import { dm_mail_trungtuyen } from "../models/response/category/dm_mail_trungtuyen";
import { apiClient } from "./apiClient";
import { SendMailTrungTuyenRequest, SendMailTrungTuyenResponse } from "../models/request/email/SendMailTrungTuyenRequest";

export const DM_MAIL_TRUNG_TUYEN_END_POINT = "dm-mail-trung-tuyen";

export const dmMailTrungTuyenApi = {
    selectAll: () => apiClient.get(DM_MAIL_TRUNG_TUYEN_END_POINT),
    detail: (id: number) => apiClient.get(`${DM_MAIL_TRUNG_TUYEN_END_POINT}/${id}`),
    insert: (payload: dm_mail_trungtuyen) => apiClient.post(DM_MAIL_TRUNG_TUYEN_END_POINT, payload),
    update: (payload: dm_mail_trungtuyen) => apiClient.put(DM_MAIL_TRUNG_TUYEN_END_POINT, payload),
    delete: (id: number) => apiClient.delete(`${DM_MAIL_TRUNG_TUYEN_END_POINT}/${id}`),
    send: (payload: SendMailTrungTuyenRequest) => apiClient.post(`${DM_MAIL_TRUNG_TUYEN_END_POINT}/send`, payload),
    getHistoryByHocSinhId: (hocSinhId: number) => apiClient.get(`${DM_MAIL_TRUNG_TUYEN_END_POINT}/history/${hocSinhId}`),
    getHistoryDetailById: (id: number) => apiClient.get(`${DM_MAIL_TRUNG_TUYEN_END_POINT}/history-detail/${id}`),
};

